
namespace Gordic.Epk.WebControls {

    interface IGEpkCommonPreSetStates {
        cnt: any,
        row: Wfl.Interface.GPodpisovaKnihaDto | null,
        sessionIxsFunFlag: boolean,
        multi: boolean,
        /** při výchozím nastavení je setChecks true a v případě, že se mění políčko podepsat nebo podepsatPřílohy, tak je false, protože chceme měnit jen stavy enabled */
        setChecks: boolean,
        dontSetVyriditButton?: boolean,
        isReadOnly?: boolean
    }

    /** třída pro předání stavů vyřízení */
    export class GEpkRowState {
        podepsat = new IEpkCheckBoxSetting();
        schvalit = new IEpkCheckBoxSetting();
        posoudit = new IEpkCheckBoxSetting();
        vzitnavedomi = new IEpkCheckBoxSetting();
        splnit = new IEpkCheckBoxSetting();
        rozhodnout = new IEpkCheckBoxSetting();
        podepsatPrilohy = new IEpkCheckBoxSetting();
        casoveRazitko = new IEpkCheckBoxSetting();
        zkonvertovat = new IEpkCheckBoxSetting();
        casoveRazitkoPriloha = new IEpkCheckBoxSetting();
        zkonvertovatPrilohy = new IEpkCheckBoxSetting();
        podepsatPrilohyNePDF = new IEpkCheckBoxSetting();

        pridelit = new IEpkCheckBoxSetting();
        predat = new IEpkCheckBoxSetting();
        schvaleniVyrizeniSpisu = new IEpkCheckBoxSetting();
    }

    /** společné metody v EPK05 */
    export class GEpkCommon {

        constructor(){

        }

        public setInitSettlementValues(_cnt: any) {

            var cnt: GContentType<GEpkDbParamsNew> = _cnt;
            var dto = new GEpkRowState();

            //#region -- OBRAZ --

            cnt.podepsat = dto.podepsat = new IEpkCheckBoxSetting(false, false, true);
            cnt.schvalit = dto.schvalit = new IEpkCheckBoxSetting(false, false, true);
            cnt.podepsataschvalit = new IEpkCheckBoxSetting(false, false, true);
            cnt.posoudit = dto.posoudit = new IEpkCheckBoxSetting(false, false, true);
            cnt.vzitnavedomi = dto.vzitnavedomi = new IEpkCheckBoxSetting(false, false, true);

            // splnit (specialita pro Ukrajinu)
            cnt.splnit = dto.splnit = new IEpkCheckBoxSetting(false, false, true);
            cnt.rozhodnout = dto.rozhodnout = new IEpkCheckBoxSetting(false, false, true);

            cnt.casoveRazitko = dto.casoveRazitko = new IEpkCheckBoxSetting(false, false, true);
            cnt.zkonvertovat = dto.zkonvertovat = new IEpkCheckBoxSetting(false, false, true);

            //#endregion

            //#region -- specialita MD --

            cnt.pridelit = dto.pridelit = new IEpkCheckBoxSetting(false, false, true);
            cnt.predat =  dto.predat = new IEpkCheckBoxSetting(false, false, true);
            cnt.schvaleniVyrizeniSpisu = dto.schvaleniVyrizeniSpisu = new IEpkCheckBoxSetting(false, false, true);

            //#endregion

            //#region -- PŘÍLOHY --

            cnt.podepsatPrilohy = dto.podepsatPrilohy = new IEpkCheckBoxSetting(false, false, false);
            cnt.casoveRazitkoPriloha = dto.casoveRazitkoPriloha = new IEpkCheckBoxSetting(false, false, false);
            cnt.zkonvertovatPrilohy = dto.zkonvertovatPrilohy = new IEpkCheckBoxSetting(false, false, false);
            cnt.podepsatPrilohyNePDF = dto.podepsatPrilohyNePDF = new IEpkCheckBoxSetting(false, false, false);

            //#endregion

            return dto;
        }

        public isRequestMineAndActive(activeRow: Gordic.Wfl.Interface.GPodpisovaKnihaDto, sessionIxsFun: string) {
            var sessionIxsFunFlag = false;
            if (activeRow != null) {
                sessionIxsFunFlag = activeRow.aktivita === 100 && sessionIxsFun === activeRow.ixs_fun_komu;
            }
            return sessionIxsFunFlag;
        }

        /**
         * Může být požadavek podepsán?
         * @param ssl_epk_zmeuko SSL EPK - Povolení změnit typ úkonu prováděný nad žádostí v podpisové knize
         * @param typPozadavku Typ požadavku
         */
        public canRequestBeSigned(ssl_epk_zmeuko: boolean, typPozadavku?: Wfl.Interface.TypPozadavkuEpk | null) {
            var povoleniZmenitTypUkonu = ssl_epk_zmeuko;
            return typPozadavku == Wfl.Interface.TypPozadavkuEpk.Podepsat
                || typPozadavku == Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit
                || (typPozadavku == Wfl.Interface.TypPozadavkuEpk.Schvalit && povoleniZmenitTypUkonu);
        }

        /**
         * Lze změnit typ požadavku?
         * @param ssl_epk_zmeuko SSL EPK - Povolení změnit typ úkonu prováděný nad žádostí v podpisové knize
         * @param typPozadavku Typ požadavku
         */
        public canChangeRequestType(ssl_epk_zmeuko: boolean, typPozadavku?: Wfl.Interface.TypPozadavkuEpk | null) {
            var povoleniZmenitTypUkonu = ssl_epk_zmeuko;
            return povoleniZmenitTypUkonu
                && (typPozadavku === Wfl.Interface.TypPozadavkuEpk.Podepsat
                    || typPozadavku === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit
                    || typPozadavku === Wfl.Interface.TypPozadavkuEpk.Schvalit);
        }

		/**
		 * Parametr rikajici jakou hodnotu pouzit pro vyber TS,
		 * zalezi na nacteni konf DPO. Bud se pouzije toto nebo následné nastavení
         * dle DB parametrů (řízení a viditelnost).
         * Výstupy:
         * -1 - nebere se šablona v potaz (lze měnit)
         * 0 - stav čas. razítka ze šablony je NE (nelze měnit)
         * 1 - stav čas. razítka ze šablony je ANO (nelze měnit)
         * 2 - šablona, dialog - předplněno Ne (lze měnit)
         * 3 - šablona, dialog - předplněno Ano  (lze měnit)
		 */
        public getPrizCasRazitko(_cnt: any, prizCasRaz: number): -1 | 0 | 1 | 2 | 3 {
            // data contentu
            var cnt: GContentType<GEpkDbParamsNew> = _cnt;
            // GIN SGN - povolení používat kategorie důvodu podpisu 
            var gin_sgn_ktgdp = cnt.EpkParams.gin_sgn_ktgdp;
            // není použito čas. razítko ze šablony důvodu podpisu
            if (prizCasRaz == -1 || gin_sgn_ktgdp == false)
                return -1;
            else {
                if (prizCasRaz == null)
                    return -1;
                return (prizCasRaz as 0 | 1 | 2 | 3);
            }
        }

        /**
         * zde probíhá nastavení property checked, visible
         * - hromadné vyřízení
         */
        public loadCheckBoxSettingsMulti(dto: GEpkRowState, row: Wfl.Interface.GPodpisovaKnihaDto, cnt: any) {

            var content: GContentType<GEpkDbParamsNew> = cnt;

            //thazmuka (3.9.2020) - původní chování u multivyřízení vynechám, protoze by to na kazdym zmenenem radku premlaskavano predchozi nastaveni

            var settlement: any = null;

            if (content.globalSettings != null) {
                settlement = content.globalSettings.get("specification-settlement");
            }

            //#region -- OBRAZ --

            // časové razítko
            this.nastavCheckBox(content.EpkParams.epk_zaskpodcr!, dto.casoveRazitko);

            if (content.EpkParams.epk_zaskpodcr === "0") { // původní chování
                if (settlement != null && settlement.checkCasRazitko != null) {
                    dto.casoveRazitko.checked = settlement.checkCasRazitko;
                }
            }

            // konvertovat obraz
            this.nastavCheckBox(content.EpkParams.epk_zaskkonv!, dto.zkonvertovat);

            if (content.EpkParams.epk_zaskkonv === 0) { // původní chování
                if (settlement != null && settlement.checkKonverze != null) {
                    dto.zkonvertovat.checked = settlement.checkKonverze;
                }
            }

            //#endregion

            //#region -- PŘÍLOHY --

            // podepsat přílohy
            this.nastavCheckBox(content.EpkParams.epk_zaskpril!, dto.podepsatPrilohy);

            if (content.EpkParams.epk_zaskpril === "0") { // původní chování
                if (settlement != null && settlement.checkPriloha != null) {
                    dto.podepsatPrilohy.checked = settlement.checkPriloha;
                }
            }

            // OZNAČENÍ PŘÍLOH K PODPISU - MO
            if (row.priz_epk_pocet != null && row.priz_epk_pocet > 0 || row.s_pri != null && row.s_pri > 0) {
                dto.podepsatPrilohy.checked = true;
            }

            // podepsat ne-PDF přílohy
            this.nastavCheckBox(content.EpkParams.epk_zasknepdfpr!, dto.podepsatPrilohyNePDF);

            if (content.EpkParams.epk_zasknepdfpr === 0) { // původní chování
                if (settlement != null && settlement.checkPodepsatPrilohyNePDF != null) {
                    dto.podepsatPrilohyNePDF.checked = settlement.checkPodepsatPrilohyNePDF;
                }
            }

            // přílohy časové razítko
            this.nastavCheckBox(content.EpkParams.epk_zaskprilcr!, dto.casoveRazitkoPriloha);

            if (content.EpkParams.epk_zaskprilcr === 0) { // původní chování
                if (settlement != null && settlement.checkCasRazitkoPriloha != null) {
                    dto.casoveRazitkoPriloha.checked = settlement.checkCasRazitkoPriloha;
                }
            }

            // zkonvertovat přílohy
            this.nastavCheckBox(content.EpkParams.epk_zaskprikonv!, dto.zkonvertovatPrilohy);

            if (content.EpkParams.epk_zaskprikonv === 0) { // původní chování
                if (settlement != null && settlement.checkKonverzePriloha != null) {
                    dto.zkonvertovatPrilohy.checked = settlement.checkKonverzePriloha;
                }
            }

            //#endregion

        }

        /** nahraje nastavení zaškrtávacích políček */
        public loadCheckBoxSettings(cnt: GContentType<GEpkDbParamsNew>, row: Wfl.Interface.GPodpisovaKnihaDto) {

            var settlement: any = null;

            if (cnt.globalSettings != null) {
                settlement = cnt.globalSettings.get("specification-settlement");
            }

            //#region -- OBRAZ --

            // časové razítko
            this.nastavCheckBox(cnt.EpkParams.epk_zaskpodcr!, cnt.casoveRazitko);

            if (cnt.EpkParams.epk_zaskpodcr === "0") { // původní chování
                if (settlement != null && settlement.checkCasRazitko != null) {
                    cnt.casoveRazitko.checked = settlement.checkCasRazitko;
                }
            }

            // konvertovat obraz
            this.nastavCheckBox(cnt.EpkParams.epk_zaskkonv!, cnt.zkonvertovat);

            if (cnt.EpkParams.epk_zaskkonv === 0) { // původní chování
                if (settlement != null && settlement.checkKonverze != null) {
                    cnt.zkonvertovat.checked = settlement.checkKonverze;
                }
            }

            //#endregion

            //#region -- PŘÍLOHY --

            // podepsat přílohy
            this.nastavCheckBox(cnt.EpkParams.epk_zaskpril!, cnt.podepsatPrilohy);

            if (cnt.EpkParams.epk_zaskpril === "0") { // původní chování
                if (settlement != null && settlement.checkPriloha != null) {
                    cnt.podepsatPrilohy.checked = settlement.checkPriloha;
                }
            }

            // OZNAČENÍ PŘÍLOH K PODPISU - MO
            if (row.priz_epk_pocet != null && row.priz_epk_pocet > 0 || row.s_pri != null && row.s_pri > 0) {
                cnt.podepsatPrilohy.checked = true;
            }

            // podepsat ne-PDF přílohy
            this.nastavCheckBox(cnt.EpkParams.epk_zasknepdfpr!, cnt.podepsatPrilohyNePDF);

            if (cnt.EpkParams.epk_zasknepdfpr === 0) { // původní chování
                if (settlement != null && settlement.checkPodepsatPrilohyNePDF != null) {
                    cnt.podepsatPrilohyNePDF.checked = settlement.checkPodepsatPrilohyNePDF;
                }
            }

            // přílohy časové razítko
            this.nastavCheckBox(cnt.EpkParams.epk_zaskprilcr!, cnt.casoveRazitkoPriloha);

            if (cnt.EpkParams.epk_zaskprilcr === 0) { // původní chování
                if (settlement != null && settlement.checkCasRazitkoPriloha != null) {
                    cnt.casoveRazitkoPriloha.checked = settlement.checkCasRazitkoPriloha;
                }
            }


            // zkonvertovat přílohy
            this.nastavCheckBox(cnt.EpkParams.epk_zaskprikonv!, cnt.zkonvertovatPrilohy);

            if (cnt.EpkParams.epk_zaskprikonv === 0) { // původní chování
                if (settlement != null && settlement.checkKonverzePriloha != null) {
                    cnt.zkonvertovatPrilohy.checked = settlement.checkKonverzePriloha;
                }
            }

            //#endregion

        }

        private nastavCheckBox(parameter: number | string, checkbox: IEpkCheckBoxSetting) {
            if (typeof parameter === "string") {
                parameter = parseInt(parameter);
            }
            // změna hodnot stavů parametru
            switch (parameter) {
                // Původní chování
                case 0:
                    checkbox.visible = true;
                    break;
                // Zobrazeno, zaskrtnuto    
                case 1:
                    checkbox.visible = true;
                    checkbox.checked = true;
                    break;
                // Zobrazeno, nezaskrtnuto
                case 2:
                    checkbox.visible = true;
                    checkbox.checked = false;
                    break;
                // Nezobrazeno, vzdy
                case 3:
                    checkbox.visible = false;
                    checkbox.checked = true;
                    break;
                // Nezobrazeno, nikdy
                case 4:
                    checkbox.visible = false;
                    checkbox.checked = false;
                    break;
            }
            return checkbox;
        }

        setVyriditButtons(_cnt: any, sessionIxsFunFlag: boolean, multi: boolean) {

            var cnt: GContentType<GEpkDbParamsNew> = _cnt;
            var MenuButtonsService = new Gordic.Epk.WebControls.MenuButtonsService();

            var outputState = MenuButtonsService.setButtons({
                gcontent: cnt, actions: cnt.actions, sessionIxsFunFlag: sessionIxsFunFlag, multi: multi
            }, {
                    vyridit: cnt.menuSchvalit.enabled, posoudit: cnt.menuPosoudit.enabled, zamitnout: cnt.menuZamitnout.enabled
            }, {
                    schvalitVyrizeniSpisu: cnt.schvaleniVyrizeniSpisu.checked,
                    pridelit: cnt.pridelit.checked, predat: cnt.predat.checked,
                    podepsat: cnt.podepsat.checked, posoudit: cnt.posoudit.checked, schvalit: cnt.schvalit.checked, vzitnavedomi: cnt.vzitnavedomi.checked,
                    rozhodnout: cnt.rozhodnout.checked, splnit: cnt.splnit.checked, podepsatPrilohy: cnt.podepsatPrilohy.checked
            });

            if (outputState!= null)
                cnt.vyriditState = outputState;
        }

        tempRow: Wfl.Interface.GPodpisovaKnihaDto


        /**
         * přednastavení stavů tlačítek v menubaru + stavů k vyřízení
         * @param setChecks při výchozím nastavení je setChecks true a v případě, že se mění políčko podepsat nebo podepsatPřílohy, tak je false, protože chceme měnit jen stavy enabled
         */
        preSetStates(opt: IGEpkCommonPreSetStates) {

            var cnt: GContentType<GEpkDbParamsNew> = opt.cnt;
            var row = opt.row;
            var sessionIxsFunFlag = opt.sessionIxsFunFlag;
            var setChecks = opt.setChecks;
            var isReadOnly = opt.isReadOnly;
            var dontSetVyriditButton = opt.dontSetVyriditButton;
            var multi = opt.multi;

            //todo: thazmuka (15.4.2020) - zde se ovládá viditelnost K Posouzeni, ja zatim mam pouize enabled
            //btnKPosouzeni.Visible = this.epk_povhrompos;

            if (row != null && sessionIxsFunFlag) {

                //#region -- CHECKED --

                if (setChecks === true && row != this.tempRow) {
                    // ošetření, aby se nenastavovali nastavené checkboxi na stejném řádku vícekrát
                    this.tempRow = row;

                    cnt.podepsat.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Podepsat || row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;
                    cnt.schvalit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Schvalit || row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit;

                    cnt.podepsatPrilohy.checked = row.s_pri !== 0 || (cnt.EpkParams.epk_zaskpril === "1");
                    cnt.posoudit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Posoudit;
                    cnt.vzitnavedomi.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.VzitNaVedomi;

                    // speciality pro UKR
                    cnt.splnit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Splnit;
                    cnt.rozhodnout.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Rozhodnout;
                    // specialita MD
                    cnt.pridelit.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Prideleni;
                    cnt.predat.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.Predani;
                    cnt.schvaleniVyrizeniSpisu.checked = row.typ_pozad_pod === Wfl.Interface.TypPozadavkuEpk.SchvalitVyrizeniSpisu;

                    this.loadCheckBoxSettings(cnt, row);

                    // thazmuka (19.8.2021) - zde se nastaví pouze hodnota čas. razítka dle db parametru (řízení a viditelnost)
                    // v případě použití šablony důvodu podpisu se hodnota nastaví při otevření dialogu upřesnění vyřízení či pak pro sichr až při samotném vyřízení
                    cnt.casoveRazitko.checked = cnt.casoveRazitko.checked && cnt.podepsat.checked;

                    cnt.zkonvertovat.checked = cnt.zkonvertovat.checked && cnt.podepsat.checked;

                    cnt.podepsatPrilohy.checked = cnt.podepsatPrilohy.checked && (cnt.podepsat.checked || this.canChangeRequestType(cnt.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod));

                    // thazmuka (19.8.2021) - zde se nastaví pouze hodnota čas. razítka (přílohy) dle db parametru (řízení a viditelnost)
                    // v případě použití šablony důvodu podpisu se hodnota nastaví při otevření dialogu upřesnění vyřízení či pak pro sichr až při samotném vyřízení
                    cnt.casoveRazitkoPriloha.checked = cnt.casoveRazitkoPriloha.checked && cnt.podepsatPrilohy.checked;

                    cnt.zkonvertovatPrilohy.checked = cnt.zkonvertovatPrilohy.checked && cnt.podepsatPrilohy.checked;
                    cnt.podepsatPrilohyNePDF.checked = cnt.podepsatPrilohyNePDF.checked && cnt.podepsatPrilohy.checked;

                }

                //#endregion

                //#region -- existuje úkon schválení --

                var existujeUkonSchvaleni = false;

                if (row.ixs_spd != null && row.ixs_spd != "") {
                    existujeUkonSchvaleni = row.poc_posouz != 0;
                }

                //#endregion

                var jizVyrizen = row.zpus_vyriz !== 0 ? true : false;
                var jeSystemovyUkon = row.sys_ukon != null ? true : false;
                var readOnly = isReadOnly == null ? false : isReadOnly;
                var jePevnaSablona = row.rezim_sch === 0 ? true : false;        // thazmuka (28.03.2021) - v případě pevné šablony nelze měnit typ žádosti

                var canRequestBeSigned = this.canRequestBeSigned(cnt.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod);
                var canChangeRequestType = this.canChangeRequestType(cnt.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod);


                //#region -- ENABLED --

                //#region -- STATES OF MENU BUTTONS --

                let customLogger = new Gordic.Diagnostics.GLog({ name: "Gordic.Epk.WebControls.GEpkCommon", fileName: "GEpkCommon.ts", authorCode: 487 });

                if (cnt.menuSchvalit != null) {
                    cnt.menuSchvalit.enabled = !readOnly && !jizVyrizen
                        && (cnt.schvaleniVyrizeniSpisu.checked || cnt.pridelit.checked || cnt.predat.checked || cnt.podepsat.checked || cnt.schvalit.checked || cnt.posoudit.checked || cnt.vzitnavedomi.checked || cnt.splnit.checked || cnt.rozhodnout.checked)
                        && (cnt.EpkOpt.povoleniUkonuPodpisuEpk! /*|| cnt.EpkOpt.ktgDpoDpoCfgPrizZnacka == 1*/);
                }

                //customLogger.trace(
                //    "Kladne vyrizeni - jizVyrizen:" + jizVyrizen +
                //    ", readOnly:" + readOnly +
                //    ", podepsat.checked:" + cnt.podepsat.checked +
                //    ", schvalit.checked:" + cnt.schvalit.checked +
                //    ", posoudit.checked:" + cnt.posoudit.checked +
                //    ", vzitnavedomi.checked:" + cnt.vzitnavedomi.checked +
                //    ", splnit.checked:" + cnt.splnit.checked +
                //    ", rozhodnout.checked:" + cnt.rozhodnout.checked +
                //    ", povoleniUkonuPodpisuEpk:" + cnt.EpkOpt.povoleniUkonuPodpisuEpk +
                ///*    ", ktgDpoDpoCfgPrizZnacka:" + cnt.EpkOpt.ktgDpoDpoCfgPrizZnacka +*/
                //    ", menuSchvalit.enabled:" + cnt.menuSchvalit.enabled);

                if (cnt.menuPosoudit != null) {
                    cnt.menuPosoudit.enabled = !readOnly && !jizVyrizen && (row.ixs_spd != null && row.ixs_spd != "") && cnt.EpkParams.epk_mozpredkpos === false ? false : true;
                }

                //customLogger.trace(
                //    "Posoudit - jizVyrizen:" + jizVyrizen +
                //    ", readOnly:" + readOnly +
                //    ", epk_mozpredkpos:" + cnt.EpkParams.epk_mozpredkpos +
                //    ", ixs_spd:" + row.ixs_spd +
                //    ", menuPosoudit.enabled:" + cnt.menuPosoudit.enabled);

                if (cnt.menuZamitnout != null) {
                    cnt.menuZamitnout.enabled = !readOnly && !jizVyrizen && !cnt.vzitnavedomi.checked;
                }

                //customLogger.trace(
                //    "Zamitnout - jizVyrizen:" + jizVyrizen +
                //    ", readOnly:" + readOnly +
                //    ", vzitnavedomi.checked:" + cnt.vzitnavedomi.checked +
                //    ", menuZamitnout.enabled:" + cnt.menuZamitnout.enabled);

                if (cnt.pridatVyrizSoubor != null) {
                    cnt.pridatVyrizSoubor.enabled = readOnly === false && jizVyrizen === false && row.aktivita === 100 && cnt.EpkParams.epk_vlvyrizdok === true;
                }

                //#endregion

                // thazmuka (29.10.2020) - po konzultaci s M.Halíkem upraveno: když lze podepsat pouze přílohy a lze měnit typy požadavků, nekontroluji schvalovací proces
                // v TK to není takto správně obslouženo
                if (cnt.EpkParams.epk_povpodppri! === true && canChangeRequestType === true) {
                    cnt.podepsat.enabled = this.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && (cnt.EpkOpt.povoleniUkonuPodpisuEpk! /*|| cnt.EpkOpt.ktgDpoDpoCfgPrizZnacka == 1*/);
                    cnt.schvalit.enabled = this.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && existujeUkonSchvaleni === false;

                }
                else {
                    cnt.podepsat.enabled = (row.dat_vyriz_plan == null || row.priz_rsp !== 10) && this.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && (cnt.EpkOpt.povoleniUkonuPodpisuEpk! /*|| cnt.EpkOpt.ktgDpoDpoCfgPrizZnacka == 1*/);
                    cnt.schvalit.enabled = (row.dat_vyriz_plan == null || row.priz_rsp !== 10) && this.jeVyrizenSysUkonKeCteni(jizVyrizen, jeSystemovyUkon, readOnly, jePevnaSablona) === false && canRequestBeSigned && canChangeRequestType && existujeUkonSchvaleni === false;
                }
            
                // TUTO HODNOTY UŽIVATEL NEMŮŽE MĚNIT (po domluvě s M.Halik 22.4.2020)
                cnt.posoudit.enabled = false;
                cnt.vzitnavedomi.enabled = false;
                cnt.splnit.enabled = false;
                cnt.rozhodnout.enabled = false;
                cnt.pridelit.enabled = false;
                cnt.predat.enabled = false;
                cnt.schvaleniVyrizeniSpisu.enabled = false;

                 // thazmuka (19.8.2021) - zde se nastaví pouze hodnota čas. razítka dle db parametru (řízení a viditelnost)
                // v případě použití šablony důvodu podpisu se hodnota nastaví při otevření dialogu upřesnění vyřízení či pak pro sichr až při samotném vyřízení
                if (cnt.EpkParams.gin_sgn_ktgdp === false)  // pokud nejsou aktivovány kategorie důvodu podpisu
                    cnt.casoveRazitko.enabled = canRequestBeSigned && cnt.podepsat.checked;

                cnt.zkonvertovat.enabled = cnt.podepsat.checked;
                cnt.podepsatPrilohy.enabled = cnt.podepsat.checked || (canRequestBeSigned && cnt.EpkParams.epk_povpodppri!);

                // thazmuka (19.8.2021) - zde se nastaví pouze hodnota čas. razítka dle db parametru (řízení a viditelnost)
                // v případě použití šablony důvodu podpisu se hodnota nastaví při otevření dialogu upřesnění vyřízení či pak pro sichr až při samotném vyřízení
                if (cnt.EpkParams.gin_sgn_ktgdp === false)  // pokud nejsou aktivovány kategorie důvodu podpisu
                    cnt.casoveRazitkoPriloha.enabled = cnt.podepsatPrilohy.checked;

                cnt.zkonvertovatPrilohy.enabled = cnt.podepsatPrilohy.checked;
                cnt.podepsatPrilohyNePDF.enabled = cnt.podepsatPrilohy.checked;

                //#endregion

            }
            else {

                if (cnt.menuPosoudit != null && cnt.menuSchvalit != null && cnt.menuZamitnout != null)
                    cnt.menuPosoudit.enabled = cnt.menuSchvalit.enabled = cnt.menuZamitnout.enabled = false;
            }

            if (dontSetVyriditButton === true) 
                return;
            

            this.setVyriditButtons(cnt, sessionIxsFunFlag, multi);

        }

        public jeVyrizenSysUkonKeCteni(jizVyrizen: boolean, jeSystemovyUkon: boolean, pouzeCteni: boolean, jePevnaSablona: boolean) {
            if (jizVyrizen === false && jeSystemovyUkon === false && pouzeCteni === false && jePevnaSablona === false) {
                return false;
            }
            else {
                return true;
            }
        }


        //#region -- DIALOG UPŘESNĚNÍ VYŘÍZENÍ --

        private upresnitVyrizeniClass: UpresnitVyrizeniFormEpk;

        /**
         * otevřít dialog upřesnit vyřízení
         */
        public showUpresneniVyrizeni(_cnt: any, sessionIxsFunFlag: boolean) {

            var dfd = $.Deferred();

            var cnt: GContentType<GEpkDbParamsNew> = _cnt;
            if (this.upresnitVyrizeniClass == null) 
                this.upresnitVyrizeniClass = new UpresnitVyrizeniFormEpk();
            this.getPrizSabCasRazitko(cnt, cnt.row?.ixs_dpo!)
                .then((sablonaCasRazitko: number) => {
                    this.setCasRazitko(cnt, sablonaCasRazitko, cnt.row!);
                    return sablonaCasRazitko;
                })
                .done((sablonaCasRazitko) => {

                    var form = this.upresnitVyrizeniClass.create({cnt: cnt, sessionIxsFunFlag: sessionIxsFunFlag, sablonaCasRazitko: sablonaCasRazitko});
                    var commandBar = this.createCommandbarUpresneniVyrizeni(cnt, form);
                    var modalElement = this.createModalWindowUpresneniVyrizeni(cnt, commandBar, form);
                    this.upresnitVyrizeniClass.setDataToForm(cnt, modalElement);

                    modalElement.on('close', () => {
                        dfd.resolve();
                    });

                })

            return dfd.promise();
        }

        //#region -- ŘÍZENÍ HODNOTY ČAS. RAZÍTKA --

        // - při aktivním nastavení kategorií důvodu podpisu

        private getWflsdpoDto(ixs_dpo: string): JQuery.Promise<Gordic.Wfl.Interface.GEpkWflsdpoDto> {
            var service = new GContent("Gordic.Epk.WebControls.GEpkActionsService");
            return service.call("GetWflsdpoDto", { IxsDpo: ixs_dpo });
        }

        public getPrizSabCasRazitko(cnt: GContentType<GEpkDbParamsNew>, ixs_dpo: string): JQuery.Promise<number> {
            var dfd = $.Deferred();
            if (cnt.EpkParams.gin_sgn_ktgdp === false)  // pokud nejsou aktivovány kategorie důvodu podpisu, neřeším a přeskakuji
                return dfd.resolve(-1).promise();
            this.getWflsdpoDto(ixs_dpo)
                .then((dto) => {
                    // thazmuka (11.8.2021)
                    //-1 - měnit lze, neřídím se šablonou
                    // 0 - čas. razítko NE, řídím se šablonou
                    // 1 - čas. razítko ANO, řídím se šablonou
                    // 2 - dialog - předplněno Ne (lze měnit)
                    // 3 - dialog - předplněno Ano (lze měnit)
                    var sablonaCasRazitko = this.getPrizCasRazitko(cnt, dto.PrizCasRaz!);
                    dfd.resolve(sablonaCasRazitko);
                })
            return dfd.promise();
        }

        // cas razitko =  -1 | 0 | 1 | 2 | 3
        private setCasRazitko(cnt: GContentType<GEpkDbParamsNew>, sablonaCasRazitko: number, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {

            if (row == null)
                return;

            var canRequestBeSigned = this.canRequestBeSigned(cnt.EpkParams.ssl_epk_zmeuko!, row.typ_pozad_pod);

            // -- ENABLED --

            cnt.casoveRazitko.enabled = sablonaCasRazitko === -1 ? canRequestBeSigned && cnt.podepsat.checked : sablonaCasRazitko === 2 || sablonaCasRazitko === 3 ? true : false;
            cnt.casoveRazitkoPriloha.enabled = sablonaCasRazitko === -1 ? canRequestBeSigned && cnt.podepsatPrilohy.checked : sablonaCasRazitko === 2 || sablonaCasRazitko === 3 ? true : false;

            // -- CHECKED --

            // # OBRAZ #

            if (sablonaCasRazitko === -1) { // nejedeme dle šablony
                cnt.casoveRazitko.checked = cnt.casoveRazitko.checked && cnt.podepsat.checked;
            }
            else {  // jedeme dle šablony  

                // NE
                if (sablonaCasRazitko === 0 || sablonaCasRazitko === 2) {
                    cnt.casoveRazitko.checked = false;
                }
                // ANO
                else if (sablonaCasRazitko === 1 || sablonaCasRazitko === 3) {
                    cnt.casoveRazitko.checked = true;
                }
            }

            // # PŘÍLOHA #

            if (sablonaCasRazitko === -1) { // nejedeme dle šablony
                cnt.casoveRazitkoPriloha.checked = cnt.casoveRazitkoPriloha.checked && cnt.podepsatPrilohy.checked;
            }
            else {  // jedeme dle šablony

                // NE
                if (sablonaCasRazitko === 0 || sablonaCasRazitko === 2) {
                    cnt.casoveRazitkoPriloha.checked = false;
                }
                // ANO
                else if (sablonaCasRazitko === 1 || sablonaCasRazitko === 3) {
                    cnt.casoveRazitkoPriloha.checked = true;
                }
            }
        }

        //#endregion


        /** 
         * vytvořit commandbar upřesnit vyřízení 
         */
        private createCommandbarUpresneniVyrizeni(cnt: GContentType<GEpkDbParamsNew>, form: JQuery<HTMLElement>) {

            var that = this;

            const commandBar: MenuParams[] = [];
            commandBar.push({
                action: cnt.actions.add(new GAction({
                    name: "actZavritUpresneni",
                    caption: "jres:32000510", //RC 32000510 : OK
                    run: function (ev: any, ctx) {
                        that.waitForValues(form)
                            .then((isValid) => {
                                if (isValid) {
                                    if (cnt.globalSettings != null) {
                                        var obj: any = {};
                                        form.findFields().gfield("model", "collect", obj);
                                        cnt.globalSettings.set("specification-settlement", obj);
                                    }
                                }
                                return ev;
                            })
                            .done((ev) => {
                                $.content(ev.currentTarget).close();
                            })
                    }
                }))
            });
            return commandBar;
        }

        /**
        * metoda, která zvaliduje formulář a vrátí výsledek validace až je formulář připraven
        * 
        * @param {JQuery<HTMLElement>} form předaný element formuláře
        * @returns {JQueryPromise<boolean>} výsledek stavu
        */
        private waitForValues(form: JQuery<HTMLElement>): JQueryPromise<boolean> {

            var dfd = $.Deferred();

            form.gform("waitForValues")
                .then(() => {
                    return form.gform("isValid");
                })
                .then((isValid) => {
                    dfd.resolve(isValid);
                })
                .fail(() => {
                    dfd.reject(false);
                })

            return dfd.promise();
        }

        /**
        * vytvořit modální okno upřesnění vyřízení
        * 
        * @param {MenuParams[]} commandBar tlačítka na modálním okně
        * @param {JQuery<HTMLElement>} form element formuláře
        */
        private createModalWindowUpresneniVyrizeni(cnt: GContentType<GEpkDbParamsNew>, commandBar: MenuParams[], form: JQuery<HTMLElement>) {

            return cnt.dialogs.showModalWindow(form, null, {
                width: 1065,
                height: 485,
                title: "jres:32000256", //RC 32000256 : Upřesnit vyřízení
                commandBar: commandBar
            });
        }

        //#endregion

    }

}
